import { LocaleProvider } from "../../i18n/LocaleContext";
import { SeoHead } from "../seo/SeoHead";
import PagePrivacyPolicy from "../pages/PagePrivacy";

export default function PrivacyRoute({ locale, messages }) {
  return (
    <LocaleProvider locale={locale} messages={messages} route="privacy">
      <SeoHead />
      <PagePrivacyPolicy />
    </LocaleProvider>
  );
}
